import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
  Text,
  ModalProps,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { IBangGiaDat } from "../_types_";
import moment from "moment";
import UploadFile from "../components/UploadFile";


interface IProps extends Omit<ModalProps, "children"> {
  currentGiaDat: IBangGiaDat;
  onSave?: (model: IBangGiaDat) => void;
}

export default function BangGiaDatAdd({
  isOpen,
  onClose,
  currentGiaDat,
  onSave,
  ...props
}: IProps) {
  const [giaDat, setGiaDat] = useState<IBangGiaDat>(currentGiaDat);

  useEffect(() => {
    setGiaDat(currentGiaDat);
  }, [currentGiaDat]);

  const handleSaveClick = async () => {
    onSave && onSave(giaDat);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" {...props}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Thêm Bảng Giá Đất</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack w="full" alignItems="flex-start">
            <Text color="gray.400">Mã bảng giá đất:</Text>
            <Input
              placeholder="Nhập mã bảng giá đất"
              _placeholder={{ opacity: 1, color: "gray.500" }}
              value={giaDat.ma}
              onChange={(e) => {
                setGiaDat({ ...giaDat, ma: e.target.value });
              }}
            />
            <Text color="gray.400">Số quyết định:</Text>
            <Input
              placeholder="Số quyết định"
              _placeholder={{ opacity: 1, color: "gray.500" }}
              value={giaDat.soQuyetDinh}
              onChange={(e) => {
                setGiaDat({ ...giaDat, soQuyetDinh: e.target.value });
              }}
            />
            <Text color="gray.400">Ngày ban hành:</Text>
            <Input
              placeholder="Ngày ban hành"
              size="md"
              type="date"
              defaultValue={
                giaDat.ngayBanHanh
                  ? moment(giaDat.ngayBanHanh).format("YYYY-MM-DD")
                  : undefined
              }
              onChange={(e) => {
                setGiaDat({ ...giaDat, ngayBanHanh: new Date(e.target.value) });
              }}
              onKeyDown={(e) => {e.preventDefault();}}
            />
            <Text color="gray.400">Cơ quan ban hành:</Text>
            <Input
              placeholder="Cơ quan ban hành"
              _placeholder={{ opacity: 1, color: "gray.500" }}
              value={giaDat.coQuanBanHanh}
              onChange={(e) => {
                setGiaDat({ ...giaDat, coQuanBanHanh: e.target.value });
              }}
            />
            <Text color="gray.400">Ngày hiệu lực:</Text>
            <Input
              placeholder="Ngày hiệu lực"
              size="md"
              type="date"
              defaultValue={
                giaDat.hieuLuc
                  ? moment(giaDat.hieuLuc).format("YYYY-MM-DD")
                  : undefined
              }
              onChange={(e) => {
                setGiaDat({ ...giaDat, hieuLuc: new Date(e.target.value) });
              }}
              onKeyDown={(e) => {e.preventDefault();}}
            />
            <Text color="gray.400">Ngày hết hiệu lực:</Text>
            <Input
              placeholder="Ngày hết hiệu lực"
              size="md"
              type="date"
              defaultValue={
                giaDat.hetHieuLuc
                  ? moment(giaDat.hetHieuLuc).format("YYYY-MM-DD")
                  : undefined
              }
              onChange={(e) => {
                setGiaDat({ ...giaDat, hetHieuLuc: new Date(e.target.value) });
              }}
              onKeyDown={(e) => {e.preventDefault();}}
            />
            <UploadFile
              title="bảng giá đất"
              onUploadSuccess={(f) => setGiaDat({ ...giaDat, fileId: f.id })}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSaveClick}
            hidden={giaDat.laLichSu}
          >
            Lưu thông tin
          </Button>
          <Button onClick={onClose}>Bỏ qua</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
